module.exports = __webpack_public_path__ + "img/img_default_empty@2x.2c98904d.png";